export const shrinkWrap = ($element) => {

    const element = $element.get(0);

    const { firstChild, lastChild } = element;

    if (
        firstChild === null
        || lastChild === null
    ) {
        return;
    }

    const range = document.createRange();
    range.setStartBefore(firstChild);
    range.setEndAfter(lastChild);

    let { width } = range.getBoundingClientRect();
    const buffer = 1;

    width = Math.ceil(width) + buffer;

    gsap.set(
        element,
        {
            width,
            boxSizing: 'content-box',
        }
    );
};

export const unshrinkWrap = ($element) => {

    gsap.set(
        $element,
        { clearProps: 'width, boxSizing' }
    );
};

